import { Injectable } from "@angular/core";
import { ApplicationInsights, ICustomProperties } from "@microsoft/applicationinsights-web";
import { SessionProvider } from "./session.provider";
import { Environment, EnvironmentService } from "./environment.service";
import { CheckOnlineService } from "./check-online.service";

@Injectable({
    providedIn: 'root',
  })
export class MonitoringService {
    
    constructor(
      private sessionProvider: SessionProvider,
      private environmentService: EnvironmentService,
      private checkOnlineService: CheckOnlineService) { 

        if (environmentService.getEnvironment() === Environment.Development) {
          return;
        }

        this.initAppInsights();

        this.checkOnlineService.connectivityState$.subscribe(state => {
          this.initAppInsights();
        });
      }

  initAppInsights() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: "372d209f-e917-4641-9619-591502fd7b8a",
        enableAutoRouteTracking: false,
        disableAjaxTracking: true,
        disableFetchTracking: true,
        loggingLevelConsole: 0,
      }
    });

    this.appInsights.loadAppInsights();
  }

  private appInsights: ApplicationInsights;

  logPageView(name?: string, url?: string) {
    if (!this.appInsightsAvailable()) {
      return;
    }

    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    if (!this.appInsightsAvailable()) {
      return;
    }

    this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if (!this.appInsightsAvailable()) {
      return;
    }

    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    if (!this.appInsightsAvailable()) {
      return;
    }

    var customProperties: ICustomProperties = {};
    var userData = this.sessionProvider.getUserData();

    customProperties['userName'] = userData != undefined ? userData.name : 'unknown';
    customProperties['app.system'] = 'Mira';
    customProperties['EnvironmentName'] = this.environmentService.getEnvironment();

    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel }, customProperties);
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    if (!this.appInsightsAvailable()) {
      return;
    }
    
    this.appInsights.trackTrace({ message: message}, properties);
  }

  appInsightsAvailable() {
    return this.appInsights !== null && this.appInsights !== undefined;
  }
}